// import DashboardWidgets from "./DashboardWidgets";
import SalaryDashboard from "./SalaryDashboard";

export default function Dashboard(props: any) {
  return (
    <>
      {/* <DashboardWidgets name="DashboardWidgets" /> */}
      <SalaryDashboard name="SalaryDashboard" />
    </>
  );
}
